import ApiClient from '@/services/apiClient';

export default class Output {
  output_number;
  label;

  constructor(output_number = 0, label = "") {
    this.output_number = output_number;
    this.label = label;
  }

  static constructFromObject(data, obj) {
    obj = obj || new Output();
    if (data) {
        obj.output_number = ApiClient.convertToType(data['output_number'], 'Integer') || 0;
    }
    return obj;
  }

  toJSON() {
    return {
      output_number: this.output_number,
    }
  }

  toString() {
      return this.label;
  }
}
